class GiftNote extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const trigger = this.querySelector('.ctm_add_to_gift_widget');
    const widgetContent = this.querySelector('.cart__widget__content');
    const giftNoteInput = this.querySelector('#giftNoteInput');
    const id = trigger?.getAttribute('data-id');

    if (!trigger || !widgetContent || !id) {
      console.warn('GiftNote component missing expected elements or data-id.');
      return;
    }

    trigger.addEventListener('click', () => {
      console.log("check box click")
      const isActive = trigger.classList.contains('active_gift_product');
      window.cart_this = window.cart_this || document.querySelector('cart-items');

      if (!isActive) {
        trigger.classList.add('active_gift_product');
        widgetContent.style.display = 'block';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id, quantity: 1 })
        })
        .then(res => res.json())
        .then(() => window.cart_this?.getCart?.())
        .catch(err => console.error('Add error:', err));
      } else {
        trigger.classList.remove('active_gift_product');
        widgetContent.style.display = 'none';
        if (giftNoteInput) giftNoteInput.value = '';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id, quantity: 0 })
        })
        .then(res => res.json())
        .then(() => window.cart_this?.getCart?.())
        .catch(err => console.error('Remove error:', err));
      }
    });
  }
}

customElements.define('gift-note', GiftNote);